export const getVerticalGridCoordinates = (
  plotLeft: number,
  plotWidth: number,
  barCount: number,
) => {
  const categoryWidth = plotWidth / barCount;

  return Array.from(
    { length: barCount + 1 },
    (_, index) => plotLeft + index * categoryWidth,
  );
};

export const getColumnLayout = (
  plotLeft: number,
  plotWidth: number,
  columnCount: number,
  columnIndex: number,
) => {
  const columnWidth = plotWidth / columnCount;
  const x = Math.round(plotLeft + columnIndex * columnWidth);
  const nextX = Math.round(plotLeft + (columnIndex + 1) * columnWidth);

  return {
    x,
    width: nextX - x,
  };
};
